import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { commonClass } from '../models/commonClass';
const LASTSYNCTIME:string='lastsynctime';
@Injectable({
  providedIn: 'root',
})
export class ErrorShowService {
  constructor(private toastr: ToastrService) {}
  errorTitle: string = "Error !!";
  successTitle: string = "Success .. ";
  warningTitle: string = "Warning .. ";

  showError(message, errCode?:number) {
    if (errCode) this.errorTitle = `${errCode}`;
    if (message.includes('cip.medsphere.net')) {
      message = "Something went wrong."
    }

    this.toastr.error(message, this.errorTitle);
  }
  showSucess(message) {
    this.toastr.success(message, this.successTitle);
  }
  showWarning(message) {
    this.toastr.warning(message, this.warningTitle);
  }

  showGallery(message) {
    this.toastr.warning(message);
  }
  showMessage(title, msg) {
   return this.toastr.info(msg, title);
  }
  SyncAndFlushData() {
    if (localStorage.getItem(LASTSYNCTIME)) {
      var lastsynctime: number = JSON.parse(localStorage.getItem(LASTSYNCTIME));
      if (lastsynctime < commonClass.LASTDEPLOYTIME) {
        this.FlushData();
      }
    }
    else {
      this.FlushData();
    }
  }
  FlushData() {
    localStorage.clear();
    localStorage.setItem(LASTSYNCTIME, JSON.stringify(new Date().getTime()).toString());
    window.location.reload();
  }
}
